var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ArticleItem',_vm._b({staticClass:"project-item-container"},'ArticleItem',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }